module.exports = __webpack_public_path__ + "static/media/askEpm.d88cecd8.png";